@if (editing(); as row) {
  <maxx-monitor-form
    [metric]="row.metric"
    [title]="row.title"
    [monitor]="row.monitor"
    [slackChannelName]="slackChannelName()"
    (saved)="onSaved($event)"
    (closed)="editing.set(null)"></maxx-monitor-form>
} @else {
  <p class="maxx-monitoring__muted body-13-regular">
    Monitors MAXX runs for you on a schedule. Each run shows up in the Insights tab.
  </p>

  @if (isLoading()) {
    <p class="maxx-monitoring__muted body-13-regular">Loading…</p>
  } @else if (loadFailed()) {
    <p class="maxx-monitoring__error body-13-regular">{{ errorMessage() }}</p>
  } @else {
    <ul class="maxx-monitoring__list">
      @for (row of rows(); track row.metric) {
        <li class="maxx-monitoring__row">
          <div class="maxx-monitoring__text">
            <span class="body-14-medium">{{ row.title }}</span>
            <span class="maxx-monitoring__muted body-12-regular">{{ row.subtitle }}</span>
          </div>
          @if (row.monitor; as monitor) {
            <button
              type="button"
              class="maxx-monitoring__status"
              pdqPopover
              [attr.aria-label]="row.title + ' status'"
              [popoverTemplate]="statusMenu"
              [forcePosition]="'bottom_right'"
              [closeOnPopoverClick]="true"
              [closeOnClickOutside]="true">
              <pdq-tag size="small" mode="rect" [variant]="row.statusVariant">
                <span class="maxx-monitoring__status-label">
                  {{ row.statusLabel }}
                  <img class="maxx-monitoring__status-arrow" src="assets/icons/dropdown_down_arrow.svg" alt="" />
                </span>
              </pdq-tag>
            </button>
            <ng-template #statusMenu>
              <pdq-popover-container [loading]="false" [actionList]="true">
                <div class="action-list">
                  <pdq-option [isSelected]="monitor.enabled" (onSelect)="setEnabled(monitor, true)">Active</pdq-option>
                  <pdq-option [isSelected]="!monitor.enabled" (onSelect)="setEnabled(monitor, false)"
                    >Paused</pdq-option
                  >
                </div>
              </pdq-popover-container>
            </ng-template>
          } @else {
            <pdq-tag size="small" mode="rect" [variant]="row.statusVariant" [value]="row.statusLabel"></pdq-tag>
          }
          <pdq-button
            pdqPopover
            variant="ghost"
            size="small"
            icon="dots_menu"
            [ariaLabel]="row.title + ' actions'"
            [popoverTemplate]="actions"
            [forcePosition]="'bottom_right'"
            [closeOnPopoverClick]="true"
            [closeOnClickOutside]="true"></pdq-button>
          <ng-template #actions>
            <pdq-popover-container [loading]="false" [actionList]="true">
              <div class="action-list">
                @if (row.monitor; as monitor) {
                  <pdq-option (onSelect)="editing.set(row)">Edit</pdq-option>
                  <pdq-option variant="danger" (onSelect)="delete(monitor)">Delete</pdq-option>
                } @else {
                  <pdq-option (onSelect)="editing.set(row)">Create</pdq-option>
                }
              </div>
            </pdq-popover-container>
          </ng-template>
        </li>
      }
    </ul>
  }
}
